import TableSimpleCell from "ds/components/TableSimple/Cell";
import SpacePath from "components/SpacePath";

import { IntegrationsAwsUsedByTableCellProps } from "./types";

const IntegrationsAwsUsedByTableSpaceCell = ({
  item: stack,
  ...cellProps
}: IntegrationsAwsUsedByTableCellProps) => {
  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath spaceId={stack.spaceDetails.id} fallbackName={stack.spaceDetails.name} />
    </TableSimpleCell>
  );
};

export default IntegrationsAwsUsedByTableSpaceCell;
